<div class="mh3 mv4">
  <div class="flex items-center fw5">
    <mat-icon class="ruby pr3">{{ strength.icon }}</mat-icon>
    <span>{{ strength.title | uppercase }}</span>
  </div>
  <p>{{ strength.description }}</p>
</div>
